function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 86",
  fill: "none",
  stroke: "#5dbeff",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("rect", {
  width: 57,
  height: 61,
  rx: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 55,
  height: 59,
  rx: 4
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 16",
  d: "M8.08 12.506l2.851 3.8 6.081-6.461",
  fill: "none",
  stroke: "#5dbeff",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 17",
  d: "M8.08 23.622l2.851 3.8 6.081-6.461",
  fill: "none",
  stroke: "#5dbeff",
  strokeWidth: 2
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 18",
  d: "M8.08 34.738l2.851 3.8 6.081-6.461",
  fill: "none",
  stroke: "#5dbeff",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 10",
  fill: "none",
  stroke: "#5dbeff",
  d: "M25.225 13.254h22.232"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 13",
  fill: "none",
  stroke: "#5dbeff",
  d: "M25.225 48.312h22.232"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 11",
  fill: "none",
  stroke: "#5dbeff",
  d: "M25.225 25.225h22.232"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 12",
  fill: "none",
  stroke: "#5dbeff",
  d: "M25.225 36.341h22.232"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Union 10",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.003 49.599l-2.049 2.049-1.288-1.287 2.049-2.05-2.049-2.049 1.288-1.288 2.049 2.049 2.05-2.049 1.287 1.288-2.049 2.049 2.049 2.05-1.287 1.287z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.053 51.648l-2.05-2.049-2.05 2.05-1.287-1.288 2.05-2.05-2.05-2.05 1.288-1.287 2.05 2.05 2.049-2.05 1.287 1.288-2.049 2.05 2.05 2.049-1.288 1.287z",
  fill: "#5dbeff"
}));

var SvgTesting = function SvgTesting(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 61",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTesting, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/testing.63bbd963.svg";
export { ForwardRef as ReactComponent };